<template>
  <div>
    <a-row :gutter="10">
      <a-col :md="6" :sm="24">
        <a-card  class="pannel-scroll"  >
          <!-- <a-button  type="primary"  @click="loadTree"  :loading="isLoaddingTreeData"  >刷新</a-button> -->
          <a-input-search
            style="margin-bottom: 0px;margin-top: 8px;"
            placeholder="请输入要搜索的内容"
            enter-button="搜索"
            size="large"
            @search="onSearch"
          />
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              当前选择：
              <span style="margin-left: 10px;color:#1890FF" v-if=" selectedTress.title">{{ selectedTress.title }}</span>
            </div>
          </a-alert>
          <a-tree
            @select="onTreeSelect"
            :tree-data="treeData"
            :expanded-keys="expandedKeys"
            :auto-expand-parent="autoExpandParent"
            :selected-keys.sync="treeSelectedKeyValue"
            @expand="onExpand"
          >
            <template slot="title" slot-scope="{ title }">
              <span v-if="title.indexOf(searchValue) > -1">
                {{ title.substr(0, title.indexOf(searchValue)) }}
                <span
                  style="color: #f50"
                >{{ searchValue }}</span>
                {{ title.substr(title.indexOf(searchValue) + searchValue.length) }}
              </span>
              <span v-else>{{ title }}</span>
            </template>
          </a-tree>
          <div>
            <a-spin tip="Loading..." :spinning="isLoaddingTreeData">
            </a-spin>
          </div>
        </a-card>
        <div class="drawer-bootom-button">
          <a-dropdown :trigger="['click']" placement="topCenter">
            <a-menu slot="overlay">
              <a-menu-item key="6" @click="closeAll">合并所有</a-menu-item>
              <a-menu-item key="6" @click="openAll">展开所有</a-menu-item>
            </a-menu>
            <a-button>
              树操作
              <a-icon type="up" />
            </a-button>
          </a-dropdown>
        </div>
      </a-col>
      <a-col :md="18" :sm="24">
        <a-card  class="pannel-scroll-right"  >
          <div  class="search-banner-div" >
              <p  class="bar-title-p">
                是否上传：
              </p>
              <div  class="isupdate-radio-div"  >
                <a-radio-group v-model="isUpdateFilter" size="large"  button-style="solid"  >
                  <a-radio-button  value="all"  >
                    全部
                  </a-radio-button>
                  <a-radio-button value="upload">
                    已上传
                  </a-radio-button>
                  <a-radio-button value="notUpload">
                    未上传
                  </a-radio-button>
                  </a-radio-group>
              </div>
              <p  class="bar-title-p">
                搜索：
              </p>
              <a-input-search
                style="margin-bottom: 0px;margin-top: 8px;"
                placeholder="请输入物料编码/物料名称"
                enter-button="搜索"
                size="large"
                @search="onSearchTable"
                class="search-input-bar"
                v-model="searchTableTextModel"
              />
          </div>
          <!-- <a-alert type="error" :showIcon="true"  v-show="!isTreeSelected"  >
            <div slot="message">
              请先选中分类
            </div>
          </a-alert> -->
          <a-alert type="info" :showIcon="true" >
            <div slot="message">
              当前选择：
              <span style="margin-left: 10px;color:#1890FF" v-if=" selectedTress.title">{{ selectedTress.title }}</span>
            </div>
          </a-alert>
          <a-table bordered :columns="columns" :data-source="tableData" rowKey="materialCode" :scroll="{ x: true }"  :loading="tableDataLoading" >
            <template v-slot:index="text"  >
              {{text}}
            </template>
            <template v-slot:imagepath="text"  >
              <template  v-if="text"  > 
                  <span  class="color-blue"  >已上传</span>
              </template>
              <template  v-else  >
                  <span  class="color-red"  >未上传</span>
              </template>
            </template>
            <template v-slot:action="itemtemp"  >
              <a  @click="onEditPicture(itemtemp)" >编辑</a>
            </template>
             <template  v-slot:customRender="text" >
              <span v-if="searchTableText">
                <template
                  v-for="(fragment, i) in text
                    .toString()
                    .split(new RegExp(`(?<=${searchTableText})|(?=${searchTableText})`, 'i'))"
                >
                  <mark
                    v-if="fragment.toLowerCase() === searchTableText.toLowerCase()"
                    :key="i"
                    class="highlight"
                    >{{ fragment }}</mark
                  >
                  <template v-else>{{ fragment }}</template>
                </template>
              </span>
              <template v-else>
                {{ text }}
              </template>
            </template>
          </a-table>
          <p  class="totals-p"  >
            共<span  class="totals-span"  >{{tableData.length}}</span>条
          </p>
        </a-card>
      </a-col>
    </a-row>
    <image-drawer-edit    ref="imageDrawerEditRef"  @updataTableImage="updataTableImage"  ></image-drawer-edit>
  </div>
</template>

<script>
import { queryMaterialTreeList, queryMaterialImageList,queryUploadOrNotUploadMaterialImageList  } from '@/api/api'
import ImageDrawerEdit from "./components/ImageDrawerEdit"
const getParentKey = (key, tree) => {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.children) {
      if (node.children.some((item) => item.key === key)) {
        parentKey = node.key
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children)
      }
    }
  }
  return parentKey
}
const columns = [
  {
    title: '序号',
    dataIndex: 'indexs',
    key:"indexs",
    width: "20px",
    align:"center"
  },
  {
    title: '物料编码',
    dataIndex: 'materialCode',
    key:"materialCode",
    width: "130px",
    scopedSlots: { customRender: 'customRender' },
    align:"center"
  },
  {
    title: '物料名称',
    dataIndex: 'materialName',
    key:"materialName",
    width: "200px",
    scopedSlots: { customRender: 'customRender' },
    align:"center"
  },
  {
    title: '是否上传',
    dataIndex: 'imagePath',
    width: "30px",
    scopedSlots: { customRender: 'imagepath' },
    align:"center"
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    align:"center",
    width: "30px",
  },
]
export default {
  created() {
    this.loadTree()
  },
  data() {
    return {
      treeSelectedKeyValue:[],
      treeData: [],
      dataList: [],
      selectedTress: {
        title: '',
        materialGroupCode: '',
      },
      tableDataLoading:false,
      columns,
      tableData: [],
      expandedKeys: [],
      searchValue: '',
      autoExpandParent: true,
      isLoaddingTreeData:false,
      searchTableText:"",
      searchTableTextModel:"",
      materialSelectItem:{
        materialCode: "",
        materialGroupCode: "",
        materialName: "",
        imagePath:"",
      },
      isUpdateFilter:"all",
      selectMaterialGroupCode:"",
    }
  },
  methods: {
    onEditPicture(item){
      this.materialSelectItem=item;
      this.$refs.imageDrawerEditRef.onDrawerOpen(item);
    },
    onTreeSelect(keys, e) {
      this.searchTableText=""
      this.searchTableTextModel=""
      this.isUpdateFilter="all"
      if (!e.selected) {
        this.$set(
          this.selectedTress,
          'title',
          ""
        )
        this.$set(this.selectedTress, 'materialGroupCode',"")
        this.findTableData()
          return
      }
      this.$set(
        this.selectedTress,
        'title',
        e.selectedNodes[0].data.props.materialGroupCode + '/' + e.selectedNodes[0].data.props.materialGroupName
      )
      this.$set(this.selectedTress, 'materialGroupCode', e.selectedNodes[0].data.props.materialGroupCode)
      this.findTableData()
    },
    findTableData(){
       if(this.searchTableText.trim()){
         this.$set(this.selectedTress,"materialGroupCode","")
         this.$set(this.selectedTress,"title","")
         this.treeSelectedKeyValue=[]
       }
       this.tableDataLoading=true;
       queryUploadOrNotUploadMaterialImageList({ materialGroupCode: this.selectedTress.materialGroupCode,type:this.isUpdateFilter,searchBoxContent:this.searchTableText })
        .then((res) => {
          if (res.success) {
            for (let index in res.result) {
              res.result[index].indexs=parseInt(index)+1
            }
            this.tableData=res.result
          } else {
            this.$message.warning(res.message)
            this.tableData=[]
          }
        })
        .catch((res) => {
          this.$message.warning(res.message)
          this.tableData=[]
        }).finally(()=>{
          this.tableDataLoading=false
        })
    },
    loadTree() {
      this.treeData=[]
      this.isLoaddingTreeData=true;
      queryMaterialTreeList({})
        .then((res) => {
          this.isLoaddingTreeData=false;
          if (res.success) {
            this.treeData = this.toTree(res.result)
            this.dataList = []
            const generateList = (data) => {
              for (let i = 0; i < data.length; i++) {
                const node = data[i]
                const titleTemp = node.materialGroupCode + '/' + node.materialGroupName
                const keyTemp = node.materialGroupCode
                this.dataList.push({ key: keyTemp, title: titleTemp })
                if (node.children) {
                  generateList(node.children)
                }
              }
            }
            generateList(this.treeData)
            this.onSearch("");
          } else {
            this.$message.warning(res.message)
          }
        })
        .catch((error) => {
          this.isLoaddingTreeData=false;
          this.$message.warning(error)
        })
    },
    toTree(data) {
      let result = []
      if (!Array.isArray(data)) {
        return result
      }
      data.forEach((item, index) => {
        data[index].title = item.materialGroupCode + '/' + item.materialGroupName
        data[index].key = item.materialGroupCode
        data[index].scopedSlots = { title: 'title' }
        delete item.children
      })
      let map = {}
      data.forEach((item) => {
        map[item.id] = item
      })
      data.forEach((item) => {
        let parent = map[item.parentId]
        if (parent) {
          (parent.children || (parent.children = [])).push(item)
        } else {
          result.push(item)
        }
      })
      return result
    },
    onSearch(value) {
      this.closeAll()
      const expandedKeys = this.dataList
        .map((item) => {
          if (item.title.indexOf(value) > -1) {
            return getParentKey(item.key, this.treeData)
          }
          return null
        })
        .filter((item, i, self) => item && self.indexOf(item) === i)
      this.autoExpandParent = true
      this.searchValue = value
      this.expandedKeys = expandedKeys
    },
    onSearchTable(value){
      this.searchTableText=value
      this.findTableData();
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    closeAll(){
      this.autoExpandParent = false
      this.searchValue = ""
      this.expandedKeys = []
    },
    openAll(){
      this.onSearch("")
    },
    updataTableImage(materialCode,imagePath){
      for (let i = 0; i < this.tableData.length; i++) {
        if(this.tableData[i].materialCode==materialCode){
          this.$set(this.tableData[i],"imagePath",imagePath)
          break;
        }       
      }
    }
  },
  watch:{
    isUpdateFilter(){
      this.findTableData();
    }
  },
  computed:{
    // searthTableData(){
    //   return this.tableData.filter((item)=>{
    //     if(item.materialCode.toLowerCase().indexOf(this.searchTableText.toLowerCase())!== -1||item.materialGroupCode.toLowerCase().indexOf(this.searchTableText.toLowerCase())!== -1||item.materialName.toLowerCase().indexOf(this.searchTableText.toLowerCase())!== -1){
    //       // if((this.isUpdateFilter=="已上传"&&!item.imagePath)||(this.isUpdateFilter=="未上传"&&item.imagePath)){
    //       //   return false
    //       // }
    //       return true
    //     }
    //     return false
    //   })
    // },
    isTreeSelected(){
      if(this.selectedTress.title){
        return true
      }
      return false
    }
  },
  components:{
    ImageDrawerEdit
  }
}
</script>

<style    scoped>
.pannel-scroll{
  height:700px;
  overflow-y: scroll;
}
.pannel-scroll-right{
  height:800px;
  overflow-y: scroll;
}
.margin-left-10{
  margin-left: 20px;
}
.drawer-bootom-button {
  /*position: absolute;*/
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: left;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.totals-p{
  width: 100px;
  position: relative;
  top: -45px;
  left: 10px;
  font-size: 16px;
}
.totals-span{
  color:#1890FF;
}
.color-red{
  color: red;
}
.color-blue{
  color: #1890FF;
}
.search-banner-div{
  display: flex;
  flex-direction: row;
  align-items:center;
  justify-content: flex-start;
  margin-bottom: 15px;
}
.isupdate-radio-div .ant-radio-group{
  white-space: nowrap;
}
.search-input-bar{
  flex-shrink: 5;
  margin-top: 0px!important;
}
.bar-title-p{
  margin-bottom:0px !important;
  white-space: nowrap;
  font-size: 17px;
  margin: 0px 10px;
}
.ant-table td { white-space: nowrap !important; }
</style>